import { cartXAtom } from "@/app/layouts/header/pc-header/helpers/pc-cart-btn/PcCartMenu";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useAtom } from "jotai";
import { CSSProperties, useEffect, useRef } from "react";

const DEFAULT_ANIMATION_DURATION = 0.9,
  DEFAULT_ITEM_STYLING: CSSProperties = { borderRadius: "4rem", width: "8rem" };
export interface IPoint {
  x: number | string;
  y: number | string;
}
interface Props {
  src: string;
  startCoord: IPoint | null;
  setStartCoord: (point: IPoint | null) => void;
  customAnimation?: string; //'' (e.g: 20%{translate:80% 80%;})
  animationDuration?: number;
  flyingItemStyling?: CSSProperties;
}

const FlyingImage: React.FC<Props> = ({
  src = "",
  startCoord,
  setStartCoord,
  customAnimation = "",
  animationDuration = DEFAULT_ANIMATION_DURATION,
  flyingItemStyling = DEFAULT_ITEM_STYLING,
}) => {
  const flyingImage = useRef<any>(null);
  const [pcCartX] = useAtom(cartXAtom);
  const mobile = useIsMobile();

  const initFlight = () => {
    flyingImage?.current?.style.setProperty(
      "--target-position-x",
      startCoord?.x + "px"
    );
    flyingImage.current?.style.setProperty(
      "--target-position-y",
      startCoord?.y + "px"
    );
    flyingImage.current?.style.setProperty("display", "");
    (flyingImage.current as any).src = src;
    setTimeout(() => {
      flyingImage.current?.style?.setProperty("display", "none");
      setStartCoord(null);
    }, animationDuration * 1000 - 100);
  };
  useEffect(() => {
    if (!flyingImage.current) return;
    startCoord && initFlight();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startCoord]);

  const customStyling = `
    .flying_image {
      --target-position-x: 0px;
      --target-position-y: 0px;
    
      display: block;
      position: fixed;
      top: var(--target-position-y);
      left: var(--target-position-x);
      translate: -50% -50%;
      animation: fly ${animationDuration}s 1;
    }
    @keyframes fly {
      0% {
        top: var(--target-position-y);
        left: var(--target-position-x);
        opacity: 1;
      }
      ${customAnimation}
      100% {
        top: ${mobile ? "95%" : "16px"};
        left: ${mobile ? "50%" : pcCartX + 40 + "px"};
        opacity: 0.2;
      }
    }
  `;
  if (!!startCoord) return null;
  return (
    <div>
      <style>{customStyling}</style>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        ref={flyingImage}
        src=""
        alt="product"
        className="flying_image"
        style={{
          display: "none",
          zIndex: 9999,
          ...DEFAULT_ITEM_STYLING,
          ...flyingItemStyling,
        }}
      />
    </div>
  );
};
export default FlyingImage;
